import { render, staticRenderFns } from "./EntradasCadastro.vue?vue&type=template&id=1caf127c&scoped=true&"
import script from "./EntradasCadastro.vue?vue&type=script&lang=js&"
export * from "./EntradasCadastro.vue?vue&type=script&lang=js&"
import style0 from "./EntradasCadastro.vue?vue&type=style&index=0&id=1caf127c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caf127c",
  null
  
)

export default component.exports